import IViewModel from './IViewModel';
import IPropertyStatus from './IPropertyStatus';

export default class BaseViewModel implements IViewModel {
    public ErrorList: Map<string, IPropertyStatus> = new Map();

    public PropertyState(propertyName: string): IPropertyStatus | null {
        const propertyStatus = this.ErrorList.get(propertyName);

        if (propertyStatus) {
            return propertyStatus;
        } else {
            return null;
        }
    }

    public IsValid(): boolean {
        for (const [key, value] of this.ErrorList) {
            if (!value.Status) {
                return false;
            }
        }

        return true;
    }
    public ValidateModel(): void {

    }

    protected ClearErrors() {
        for (const [key, value] of this.ErrorList) {
            value.Status = true;
        }
    }
}

export function Required(message: string) {
    return function (target: object, name: string) {
        Object.defineProperty(target, name, {
            get() { return this['_' + name]; },
            set(value) {
                this['_' + name] = value;
                if (value == null || (typeof (value) === 'string' && (value.length === 0 || !value.trim()))) {
                    if (this.ErrorList) {
                        this.ErrorList.set(name, { Status: false, Message: message });
                    }
                } else {
                    if (this.ErrorList) {
                        this.ErrorList.set(name, { Status: true, Message: '' });
                    }
                }
            },
            enumerable: true,
            configurable: true
        });
    };
}
